import { minCount } from './ratio.ts';
import type { QuorumCheck, QuorumRule } from './types.ts';

export function checkQuorum(present: number, total: number, q: QuorumRule): QuorumCheck {
  const need = q.type === 'fixed' ? q.value : minCount(total, q.value, q.strict);
  const min = Math.min(need, total);
  return { ok: present >= min, need: min };
}
